// Hand-authored stick-figure reference poses shown next to each frame upload slot in the
// Animation Maker, so a GM drawing/generating frames one at a time keeps every frame
// cohesive with the last. Coordinates are in a 100 x 150 viewBox.
const NEUTRAL = {
  head: [50, 20], neck: [50, 30], hip: [50, 80],
  leftShoulder: [42, 35], leftElbow: [38, 55], leftHand: [36, 75],
  rightShoulder: [58, 35], rightElbow: [62, 55], rightHand: [64, 75],
  leftHip: [44, 80], leftKnee: [44, 110], leftFoot: [44, 140],
  rightHip: [56, 80], rightKnee: [56, 110], rightFoot: [56, 140],
};

export const CLIP_POSES = {
  idle: [
    { label: "Neutral stand", pose: NEUTRAL },
    {
      label: "Slight breathing bob",
      pose: {
        head: [50, 18], neck: [50, 28], hip: [50, 78],
        leftShoulder: [40, 33], leftElbow: [35, 53], leftHand: [32, 73],
        rightShoulder: [60, 33], rightElbow: [65, 53], rightHand: [68, 73],
        leftHip: [44, 78], leftKnee: [44, 109], leftFoot: [44, 140],
        rightHip: [56, 78], rightKnee: [56, 109], rightFoot: [56, 140],
      },
    },
  ],
  walk: [
    {
      label: "Contact — left leg forward",
      pose: {
        head: [50, 20], neck: [50, 30], hip: [50, 78],
        leftShoulder: [42, 34], leftElbow: [36, 50], leftHand: [33, 66],
        rightShoulder: [58, 34], rightElbow: [66, 48], rightHand: [70, 58],
        leftHip: [45, 78], leftKnee: [38, 106], leftFoot: [30, 136],
        rightHip: [55, 78], rightKnee: [60, 106], rightFoot: [66, 132],
      },
    },
    {
      label: "Passing — legs crossing",
      pose: {
        head: [50, 18], neck: [50, 28], hip: [50, 76],
        leftShoulder: [43, 32], leftElbow: [40, 50], leftHand: [38, 68],
        rightShoulder: [57, 32], rightElbow: [60, 50], rightHand: [62, 68],
        leftHip: [47, 76], leftKnee: [46, 106], leftFoot: [44, 136],
        rightHip: [53, 76], rightKnee: [54, 106], rightFoot: [56, 136],
      },
    },
    {
      label: "Contact — right leg forward",
      pose: {
        head: [50, 20], neck: [50, 30], hip: [50, 78],
        leftShoulder: [42, 34], leftElbow: [34, 48], leftHand: [30, 58],
        rightShoulder: [58, 34], rightElbow: [64, 50], rightHand: [67, 66],
        leftHip: [45, 78], leftKnee: [40, 106], leftFoot: [34, 132],
        rightHip: [55, 78], rightKnee: [62, 106], rightFoot: [70, 136],
      },
    },
    {
      label: "Passing — mirrored",
      pose: {
        head: [50, 18], neck: [50, 28], hip: [50, 76],
        leftShoulder: [43, 32], leftElbow: [40, 50], leftHand: [38, 68],
        rightShoulder: [57, 32], rightElbow: [60, 50], rightHand: [62, 68],
        leftHip: [47, 76], leftKnee: [48, 106], leftFoot: [50, 136],
        rightHip: [53, 76], rightKnee: [52, 106], rightFoot: [50, 136],
      },
    },
  ],
  attack: [
    {
      label: "Wind-up",
      pose: {
        head: [52, 20], neck: [51, 30], hip: [50, 78],
        leftShoulder: [41, 35], leftElbow: [35, 45], leftHand: [30, 40],
        rightShoulder: [60, 33], rightElbow: [68, 20], rightHand: [74, 10],
        leftHip: [44, 78], leftKnee: [40, 108], leftFoot: [34, 138],
        rightHip: [56, 78], rightKnee: [60, 106], rightFoot: [64, 134],
      },
    },
    {
      label: "Strike",
      pose: {
        head: [48, 22], neck: [49, 32], hip: [50, 80],
        leftShoulder: [40, 36], leftElbow: [32, 48], leftHand: [26, 56],
        rightShoulder: [59, 34], rightElbow: [50, 50], rightHand: [38, 64],
        leftHip: [42, 80], leftKnee: [34, 106], leftFoot: [26, 130],
        rightHip: [58, 80], rightKnee: [64, 110], rightFoot: [70, 136],
      },
    },
    {
      label: "Recovery",
      pose: {
        head: [50, 20], neck: [50, 30], hip: [50, 79],
        leftShoulder: [41, 35], leftElbow: [35, 50], leftHand: [30, 62],
        rightShoulder: [59, 34], rightElbow: [56, 54], rightHand: [48, 70],
        leftHip: [45, 79], leftKnee: [40, 108], leftFoot: [34, 136],
        rightHip: [55, 79], rightKnee: [58, 108], rightFoot: [62, 136],
      },
    },
  ],
  death: [
    {
      label: "Stagger / hit reaction",
      pose: {
        head: [56, 26], neck: [54, 36], hip: [50, 80],
        leftShoulder: [44, 40], leftElbow: [32, 34], leftHand: [22, 28],
        rightShoulder: [62, 38], rightElbow: [74, 32], rightHand: [84, 26],
        leftHip: [46, 80], leftKnee: [40, 105], leftFoot: [34, 130],
        rightHip: [56, 80], rightKnee: [64, 100], rightFoot: [70, 118],
      },
    },
    {
      label: "Falling",
      pose: {
        head: [72, 55], neck: [64, 58], hip: [48, 80],
        leftShoulder: [60, 62], leftElbow: [50, 50], leftHand: [40, 44],
        rightShoulder: [68, 54], rightElbow: [80, 50], rightHand: [90, 48],
        leftHip: [44, 80], leftKnee: [30, 90], leftFoot: [16, 96],
        rightHip: [52, 80], rightKnee: [64, 92], rightFoot: [78, 98],
      },
    },
    {
      label: "Fallen (held)",
      pose: {
        head: [88, 110], neck: [74, 112], hip: [46, 114],
        leftShoulder: [68, 116], leftElbow: [56, 108], leftHand: [44, 102],
        rightShoulder: [72, 108], rightElbow: [84, 104], rightHand: [94, 100],
        leftHip: [40, 114], leftKnee: [24, 116], leftFoot: [8, 118],
        rightHip: [46, 118], rightKnee: [30, 120], rightFoot: [14, 122],
      },
    },
  ],
  resurrection: [
    {
      label: "Lying flat",
      pose: {
        head: [88, 110], neck: [74, 112], hip: [46, 114],
        leftShoulder: [68, 116], leftElbow: [56, 108], leftHand: [44, 102],
        rightShoulder: [72, 108], rightElbow: [84, 104], rightHand: [94, 100],
        leftHip: [40, 114], leftKnee: [24, 116], leftFoot: [8, 118],
        rightHip: [46, 118], rightKnee: [30, 120], rightFoot: [14, 122],
      },
    },
    {
      label: "Rising, reaching up",
      pose: {
        head: [60, 80], neck: [56, 86], hip: [46, 110],
        leftShoulder: [54, 90], leftElbow: [48, 100], leftHand: [40, 112],
        rightShoulder: [62, 84], rightElbow: [70, 70], rightHand: [76, 58],
        leftHip: [40, 110], leftKnee: [30, 120], leftFoot: [18, 124],
        rightHip: [48, 112], rightKnee: [52, 128], rightFoot: [56, 138],
      },
    },
    {
      label: "Standing restored",
      pose: {
        head: [50, 16], neck: [50, 26], hip: [50, 76],
        leftShoulder: [40, 30], leftElbow: [32, 16], leftHand: [26, 4],
        rightShoulder: [60, 30], rightElbow: [68, 16], rightHand: [74, 4],
        leftHip: [45, 76], leftKnee: [44, 106], leftFoot: [42, 138],
        rightHip: [55, 76], rightKnee: [56, 106], rightFoot: [58, 138],
      },
    },
  ],
  hit: [
    {
      label: "Impact recoil",
      pose: {
        head: [58, 24], neck: [55, 32], hip: [50, 80],
        leftShoulder: [46, 36], leftElbow: [36, 30], leftHand: [28, 24],
        rightShoulder: [62, 34], rightElbow: [72, 28], rightHand: [80, 22],
        leftHip: [46, 80], leftKnee: [42, 108], leftFoot: [38, 136],
        rightHip: [56, 80], rightKnee: [62, 106], rightFoot: [66, 132],
      },
    },
    {
      label: "Recovering",
      pose: {
        head: [50, 20], neck: [50, 30], hip: [50, 79],
        leftShoulder: [42, 35], leftElbow: [37, 53], leftHand: [34, 71],
        rightShoulder: [58, 35], rightElbow: [63, 53], rightHand: [66, 71],
        leftHip: [45, 79], leftKnee: [44, 108], leftFoot: [43, 138],
        rightHip: [55, 79], rightKnee: [56, 108], rightFoot: [57, 138],
      },
    },
  ],
};

// Which attack-type tags a GM can associate an Attack Variant with (checkbox, multiple
// allowed) in the Animation Maker — purely descriptive/self-tagged, per user's explicit ask
// ("don't have to put them with the weapon... they know how they're attacking").
export const ATTACK_TYPES = [
  { key: "melee", label: "Melee" },
  { key: "magic", label: "Magic" },
  { key: "bow", label: "Bow" },
  { key: "throwing", label: "Throwing / Thrown" },
];

// Mirrors the backend's `CLIP_SPECS` — how many frames each clip type needs.
export const CLIP_FRAME_COUNTS = { idle: 2, walk: 4, attack: 3, death: 3, resurrection: 3, hit: 2 };

export const CLIP_META = {
  idle: { label: "Idle", defaultFps: 3, loop: "loop", required: false },
  walk: { label: "Walk", defaultFps: 6, loop: "loop", required: false },
  attack: { label: "Attack", defaultFps: 10, loop: "once_return", required: false },
  death: { label: "Death", defaultFps: 6, loop: "hold_last", required: false },
  resurrection: { label: "Resurrection", defaultFps: 5, loop: "once_return", required: false },
  hit: { label: "Getting Hit", defaultFps: 8, loop: "once_return", required: false },
};

// Every Attack Variant (regardless of its type tags) shares the Attack clip's fps default,
// loop behavior, and stick-figure pose guide.
export function getClipMeta(clipKey) {
  if (clipKey.startsWith("attack")) return CLIP_META.attack;
  return CLIP_META[clipKey];
}
